module.exports = __webpack_public_path__ + "static/media/article.df6c2110.png";